var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"myGridTest"},[_c('MyButton',{staticClass:"testb",attrs:{"t1":"Delete","t2":"Account","icon":"envelope","ic":"rgb(0, 217, 255)","bc1":"rgba(0, 132, 255, 0.616)","bc2":"rgba(0, 255, 221, 0.61)"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }